module.exports = __webpack_public_path__ + "static/img/3.982e758.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner2/3.png
// module id = 5E2I
// module chunks = 14